import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../../configs/translations'
import { MdfOverviewCard } from '../../../mdfOverviewCard'

import styles from './LinkageOverviewCard.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.overview.linkage

interface ILinkageOverviewCardProps {
  total: number
  linked: number
  unlinked: number
  onUnlinkedClick: () => void
}

export const LinkageOverviewCard = ({
  total,
  linked,
  unlinked,
  onUnlinkedClick,
}: ILinkageOverviewCardProps) => (
  <MdfOverviewCard
    title={KEYS.title}
    value={total}
    footer={
      <div className={styles.linkedUnlinkedFooter}>
        {!(linked > 0 || unlinked > 0) && <Translation text={KEYS.footerTitle} />}
        {linked > 0 && (
          <Translation
            text={KEYS.linked}
            replaceParams={[{ key: '{count}', value: String(linked) }]}
          />
        )}
        {unlinked > 0 && (
          <Button
            className={styles.unlinkedLink}
            variant="text"
            color="danger"
            size="sm"
            onClick={onUnlinkedClick}
          >
            <Translation
              text={KEYS.unlinked}
              replaceParams={[{ key: '{count}', value: String(unlinked) }]}
            />
          </Button>
        )}
      </div>
    }
  />
)

LinkageOverviewCard.displayName = 'LinkageOverviewCard'
